import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { LinkAboutBgtViewerComponent } from '../shared/link-about-bgt-viewer/link-about-bgt-viewer.component';
import { LinkDownloadBgtComponent } from '../shared/link-download-bgt/link-download-bgt.component';
import { LinkBgtWfsComponent } from '../shared/link-bgt-wfs/link-bgt-wfs.component';
import { CallToActionComponent } from '../shared/call-to-action/call-to-action.component';

@Component({
    selector: 'app-about-bgt',
    templateUrl: './about-bgt.component.html',
    styleUrls: ['./about-bgt.component.scss'],
    imports: [MatIcon, RouterLink, LinkAboutBgtViewerComponent, LinkDownloadBgtComponent, LinkBgtWfsComponent, CallToActionComponent]
})
export class AboutBgtComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
